export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-slate-900 dark:text-slate-100 mb-6">
          Privacy Policy
        </h1>

        <div className="prose prose-slate dark:prose-invert max-w-none">
          <p className="text-slate-600 dark:text-slate-400 mb-4">
            Last updated: November 25, 2025
          </p>
          <p className="text-slate-600 dark:text-slate-400 mb-8">
            Privacy Forum is operated by <strong>maxint.dev</strong>. This privacy policy describes how we collect, use, and protect your information.
          </p>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Information We Collect
            </h2>
            <div className="space-y-4 text-slate-700 dark:text-slate-300">
              <div>
                <h3 className="font-semibold text-slate-900 dark:text-slate-100 mb-2">Account Information</h3>
                <p>When you register, we collect your WebAuthn credentials and chosen username. We do not store passwords.</p>
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 dark:text-slate-100 mb-2">Content</h3>
                <p>Posts, comments, messages, and marketplace listings you create are stored securely. Private messages are end-to-end encrypted.</p>
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 dark:text-slate-100 mb-2">Usage Data</h3>
                <p>We collect minimal analytics to improve the platform: page views, feature usage, and error reports.</p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              How We Use Your Information
            </h2>
            <ul className="space-y-2 text-slate-700 dark:text-slate-300">
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Provide and maintain our services</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Improve user experience and platform features</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Prevent fraud and enforce our terms of service</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Comply with legal obligations</span>
              </li>
            </ul>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Data Sharing
            </h2>
            <p className="text-slate-700 dark:text-slate-300 mb-4">
              We do not sell, rent, or share your personal information with third parties except:
            </p>
            <ul className="space-y-2 text-slate-700 dark:text-slate-300">
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>When required by law or legal process</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>To protect our rights, property, or safety</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>With your explicit consent</span>
              </li>
            </ul>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Your Rights
            </h2>
            <p className="text-slate-700 dark:text-slate-300 mb-4">
              You have the right to:
            </p>
            <ul className="space-y-2 text-slate-700 dark:text-slate-300">
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Access your personal data</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Correct inaccurate data</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Request deletion of your data</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Export your data in a portable format</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Opt-out of marketing communications</span>
              </li>
            </ul>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Security
            </h2>
            <p className="text-slate-700 dark:text-slate-300">
              We implement industry-standard security measures including encryption, secure authentication,
              and regular security audits. However, no method of transmission over the internet is 100% secure.
              We encourage you to use strong authentication methods and report any security concerns immediately.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
